const a=(a,r)=>Array.from(new Map(a.map((a=>[r(a),a]))).values());export{a as getUniqueItemsBySelector};
